import { render, staticRenderFns } from "./SummaryCustomer.vue?vue&type=template&id=9497d9ca"
import script from "./SummaryCustomer.vue?vue&type=script&lang=js"
export * from "./SummaryCustomer.vue?vue&type=script&lang=js"
import style0 from "./SummaryCustomer.vue?vue&type=style&index=0&id=9497d9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports